import React, { useContext } from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  useNotify,
  useRefresh,
  required,
} from "react-admin";
import Transformer from "src/common/Transformer";
import { FileInput } from "src/components/file-input";
import { Grid } from "@mui/material";
import { CategoryContext } from "./CategoryList";
import { EditorBuilderInput, ColorInput } from "src/components/input";

export function CategoryCreate() {
  const { currentParent } = useContext(CategoryContext);
 
  const notify = useNotify();
  const refresh = useRefresh();

  const lastPossition = currentParent?.children ? Math.max(...currentParent.children.map(c => c.position)) : 0;

  const transform = async (data) => {
    Transformer(data, {
      update: {
        parent: currentParent ? currentParent.id : null,
        position: lastPossition+1,
      },
    });

    return data;
  };

  const onSuccess = (data) => {
    notify("ra-tree.item_created");
    refresh();
  };

  return (
    <Create transform={transform} mutationOptions={{ onSuccess }}>
      <SimpleForm>
        <Grid container sm={12} lg={6} rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12}>
            <TextInput source="legacy_id"/>
          </Grid>
          <Grid item sm={12}>
            <TextInput source="name" validate={required()} />
          </Grid>
          <Grid item sm={12}>
            <TextInput source="slug" />
          </Grid>
          <Grid item sm={12}>
            <EditorBuilderInput source="description" base64 fullWidth/>
          </Grid>
          <Grid item sm={12}>
              <ColorInput source="marker" label="Color Marker"/>
          </Grid>
          <Grid item sm={12}>
            <FileInput
              source="image"
              fileTypes={["JPG", "JPEG", "PNG", "GIF", "WEBP", "PDF", "XLS", "XLSX", "DOCX"]}
              multiple={false}
            />
          </Grid>
          <Grid item sm={12}>
            <FileInput
              source="banner"
              fileTypes={["JPG", "JPEG", "PNG", "GIF", "WEBP", "PDF", "XLS", "XLSX", "DOCX"]}
              multiple={false}
            />
          </Grid>
          <Grid item sm={12}>
            <FileInput
              source="mobile_banner"
              fileTypes={["JPG", "JPEG", "PNG", "GIF", "WEBP", "PDF", "XLS", "XLSX", "DOCX"]}
              multiple={false}
            />
          </Grid>
          <Grid item sm={12}>
              <TextInput source="meta_title"/>
          </Grid>
          <Grid item sm={12}>
            <TextInput
              source="meta_description"
              rows={4}
              fullWidth
              multiline
            />
          </Grid>
          <Grid item sm={12}>
            <TextInput source="meta_keywords" multiline rows={4}/>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
}
